module.exports = __webpack_public_path__ + "media/images/sp/brands/an/main-visual-text-191d706a00987b900aa822d4f32161fa.svg";